import React, { useState, useEffect } from "react";
import "./OperatorDetail.scss";
import CustomForm from "../../UI/CustomForm/CustomForm";
import { EditOperator } from "../../../util/API/operator";
import { Box } from "@mui/material";
import CustomAlert from "../../UI/CustomAlert/CustomAlert";

function OperatorDetail({ selectedUser, operatorDetails, handleClose, fetchOperators }) {

  console.log(selectedUser, operatorDetails);

  let agent = JSON.parse(sessionStorage.getItem("user")).payload?.body;

  const [initialDetails, setInitialDetails] = useState(null); // Save a copy of the initial details
  const [alert, setAlert] = useState({
    showAlert: false,
    message: '',
    severity: '',
    header: ''
  });

  useEffect(() => {
    if (operatorDetails) {
      setInitialDetails(operatorDetails); // Save a copy of the initial details
    }
  }, []);

  const handleUpdateOperator = async(data, formData) => {
    console.log(data, initialDetails);

    const updatedData = { ...data };

    // Compare the initial details with the updated data
    if (initialDetails && initialDetails.status !== data.status) {
      updatedData.statusChanged = true; // Add the `statusChanged` attribute if status has changed
    }

    console.log(updatedData);

    const updateOperator = await EditOperator(
      updatedData,
      selectedUser,
      agent['User'].id
    ).then((response) => {
      console.log(response);
      if ((updatedData?.statusChanged && response?.payload?.data?.callStatus == "1") || response?.Status === "1") {
      setAlert({
        showAlert: true,
        message: "Operator updated successfully",
        severity: "success",
        header: "Success",
      })

      fetchOperators();
    }
    else {
      setAlert({
        showAlert: true,
        message: "Operator update failed",
        severity: "error",
        header: "Error",
      })
    }
  });

  }

  return (
    <Box className="user-accounts-tab user-agent-details">

      {/* <Typography className="accounts-tab-header"> Operator Account Details</Typography> */}
      {selectedUser === null ? (
        <></>
      ) : (
        <Box className="balance-container"
        sx={{
          display: "flex",
          justifyContent: "center", /* Center the panels horizontally */
          alignItems: "flex-start", /* Align panels at the top */
        }}
        >
          <CustomForm
            formName="operatordetail"
            buttonAlignment={"center"}
            buttonText={"Update Operator"}
            loadingButtonText={"Updating Operator ..."}
            formValues={operatorDetails}
            onSubmit={handleUpdateOperator}
            twoColumns={true}
            buttonInPanel={true}
          />
        </Box>
      )}

        <CustomAlert
          severity={alert.severity}
          show={alert.showAlert}
          header={alert.header}
          message={alert.message}
          onClick={() => {setAlert({ ...alert, showAlert: false }); handleClose();}}
          autoclose={alert.severity === "error" ? false : true}
        />
    </Box>
  );
}

export default OperatorDetail;
